import { React, classNames } from '@digsup/core-ui';
import { Text } from '@digsup/components-text';
import PropTypes from 'prop-types';
import { styles } from './Pricing.scss';

const cx = classNames.bind(styles);

export const Pricing = ({ children }) => (
  <div className={cx('l-homepage-pricing')} id="pricing">
    <div className="l-homepage-pricing__wrapper">
      <div className="l-homepage-pricing__header">
        <Text
          size={{ xsmall: 'sm', large: '2xl' }}
          fontFamily="serif"
          fontWeight="semibold"
          marginBottom="small"
          className="u-margin-bottom-none@large">
          Plans for your future
        </Text>
        <Text size="3xs">Share your subscription with others</Text>
      </div>
      {children}
    </div>
  </div>
);

Pricing.propTypes = {
  children: PropTypes.any,
};
